import DashboardPage from "@modules/dashboard/DashboardPage";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import RouteContainer from "../components/core/RouteContainer";
import MasterLayout from "../components/layouts/MasterLayout";

const SettingsPage = lazy(() => import("@modules/settings/SettingsPage"));
const UsersPage = lazy(() => import("@modules/users/UserPage"));
const ErrorPage = lazy(() => import("@modules/error/ErrorPage"));

const paths = [
  { path: "/auth/*", element: <Navigate to="/dashboard" /> },
  { path: "/dashboard/*", element: <DashboardPage /> },
  { path: "/error/*", element: <ErrorPage code={404} /> },
  { path: "/settings/*", element: <SettingsPage /> },
  { path: "/users/*", element: <UsersPage /> },
];

export default function PrivateRoutes() {
  return <RouteContainer paths={paths} layout={<MasterLayout />} />;
}
